import { useEffect, useState } from "react";
import { API_EMPLOYEE_PRODUCTIVITY } from "services/apiEmployeeProductivity";
import { useFetch } from "services/useFetch";
import Filter from "../../../components/commons/filter";
import { deepClone } from "../../../utils/utils";

const FILTER = {
    DEPARTMENT: 'departments',
    DIVISION: 'divisions',
}

const QUERY_PARAMS = {
    [FILTER.DEPARTMENT]: 'departments',
    [FILTER.DIVISION]: 'divisions',
}

const INITIAL_DATA_FILTER = [
    {label: 'Department', value: FILTER.DEPARTMENT},
    {label: 'Divisi', value: FILTER.DIVISION},
]

const INITIAL_FILTER = {
    departments: [],
    divisions: [],
}

export const EmployeeProductivityFilterContainer = ({onSubmit, queryFilter}) => {
    const [show, setShow] = useState(false)
    const [activeFilter, setActiveFilter] = useState(INITIAL_DATA_FILTER[0])
    const [filter, setFilter] = useState(INITIAL_FILTER)
    const [filterCount, setFilterCount] = useState()
    const [errorFilter, setErrorFilter] = useState({})
    const [options, setOptions] = useState()

    const {fetching: getDepartmentList} = useFetch(API_EMPLOYEE_PRODUCTIVITY.LIST_DEPARTMENT)
    const {fetching: getDivisionList} = useFetch(API_EMPLOYEE_PRODUCTIVITY.LIST_DIVISION)

    useEffect(() => {
        ;(async () => {
            const [departmentList, divisionList] = await Promise.all([
                getDepartmentList(),
                queryFilter?.department_ids?.length && getDivisionList({ department_ids: queryFilter?.department_ids }),
            ])

            setOptions({
                [FILTER.DEPARTMENT]: departmentList?.data,
                [FILTER.DIVISION]: queryFilter?.department_ids?.length ? divisionList?.data : [],
            })
        })()
    }, [])
    
    useEffect(() => {
        if (queryFilter) {
            const newQueryFilter = deepClone(queryFilter)
            setFilter(newQueryFilter)
            countFilterLength(newQueryFilter)
        }
    }, [queryFilter])

    const onCloseHandler = () => {
        setShow(false)
        setErrorFilter({})
    }

    const onSelectFilter = (item) => {
        const needFetchDivision =
            item?.value === 'divisions' && options?.divisions?.length === 0 && filter?.departments?.length

        if (!needFetchDivision) return setActiveFilter(item)

        getDivisionList({ department_ids: filter?.departments })
            .then(res => {
                setOptions({
                    ...options,
                    [FILTER.DIVISION]: res.data
                })
                setActiveFilter(item)
            })
    }

    const onChangeOption = (item) => {
        const { name, value, checked } = item
        const arrChecked = filter?.[QUERY_PARAMS[name]] || []

        if (name === 'departments') {
            setOptions({
                ...options,
                [FILTER.DIVISION]: []
            })
        }

        if (checked) {
            arrChecked.push(String(value))
        } else {
            const indexRemove = arrChecked.indexOf(String(value))
            arrChecked.splice(indexRemove, 1)
        }

        setFilter({ 
            ...filter, 
            [QUERY_PARAMS[name]]: arrChecked,
            ...(name === 'departments' && {[QUERY_PARAMS[FILTER.DIVISION]]: []})
        })
    }

    const validateFilter = (query) => {
        return new Promise((resolve, reject) => {
            const errors = {}
            setErrorFilter(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmitFilter = () => {
        const queryFilter = {...filter}
        validateFilter(queryFilter)
            .then(() => {
                Object.entries(queryFilter).forEach(([key, item]) => {
                    if (Array.isArray(queryFilter[key])) queryFilter[key] = item.join(',')
                })
                onSubmit(queryFilter)
                onCloseHandler()
            })
    }

    const countFilterLength = (filter) => {
        let totalLength = 0
        for (const key in filter) {
            if (filter.hasOwnProperty(key)) {
                if (Array.isArray(filter[key])) {
                    totalLength += filter[key].length;
                } else {
                    totalLength += 1;
                }
            }
        }
        setFilterCount(totalLength)
    }

    const onClearFilter = () => {
        setFilter(deepClone(INITIAL_FILTER))
        setErrorFilter({})
        setOptions({
            ...options,
            [FILTER.DIVISION]: []
        })
        setActiveFilter(INITIAL_DATA_FILTER[0])
    }

    const props = {
        show: show,
        onShow: () => setShow(true),
        onClose: onCloseHandler,
        queryParams: QUERY_PARAMS,
        filterList: INITIAL_DATA_FILTER,
        activeFilter,
        onSelectFilter,
        filter,
        filterCount,
        options,
        onChangeOption,
        onSubmitFilter,
        onClearFilter,
        errorFilter
    }

    return (
        <Filter {...props}/>
    )
}
